import React, {useState} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    getAuth,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    browserLocalPersistence,
} from 'firebase/auth';

import './LoginPage.css';
import {Button} from "react-bootstrap";
import {Helmet} from "react-helmet-async";

const LoginPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const auth = getAuth();
    const from = location.state?.from?.pathname || '/';

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            await auth.setPersistence(browserLocalPersistence);
            await signInWithEmailAndPassword(auth, email, password);

            navigate(from, { replace: true });
        } catch (err) {
            console.error(err.message);
            setError('Login failed or data retrieval error.');
        }
    };

    const handleForgotPassword = async () => {
        if (!email) {
            setError('Please enter your email to reset the password.');
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);
            alert('A password reset link has been sent to your email.');
            setError(null);
        } catch (err) {
            console.error(err.message);
            setError('Failed to send password reset email. Please try again.');
        }
    };

    return (
        <div className="login-page">

            <Helmet>
                <title>Molnfastigheter</title>
            </Helmet>

            <div className="login-left">
                <div className="logo-section">
                    <img
                        src="/Images/molnfastigheter_logo_white.png"
                        alt="Molnfastigheter"
                        className="logo-image"
                    />
                </div>

                <form onSubmit={handleLogin} className="login-form">
                    {error && <div className="error-message">{error}</div>}

                    <span className={"field-title"}>
                        E-postadress
                    </span>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setError(null);
                        }}
                        required
                        className="input-field"
                    />

                    <span className={"field-title"}>
                        Lösenord
                    </span>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setError(null);
                        }}
                        required
                        className="input-field"
                    />

                    <Button
                        variant={"outline-light"}
                        className="mx-auto block mt-5 text-sm"
                        style={{borderWidth: '2px', width: '120px'}}
                        type={"submit"}
                    >
                        Logga in
                    </Button>

                    <button
                        type="button"
                        onClick={handleForgotPassword}
                        className="forgot-password-button"
                        style={{
                            marginTop: '20px'
                        }}
                    >
                        Glömt lösenord?
                    </button>
                </form>
            </div>

            <div className="login-right"
                 style={{
                     backgroundImage: `url('Images/vastkuststiftelsen.jpg')`,
                     position: 'relative'  // Add this to enable absolute positioning of the logo
                 }}>
                <div
                    style={{
                        position: 'absolute',
                        bottom: '26px',
                        right: '26px',
                        backgroundColor: 'white',
                        padding: '10px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                >
                    <img
                        src="/Images/vastkuststiftelsen_logo.png"
                        alt="Logo"
                        style={{
                            width: '200px',
                            height: 'auto',
                            display: 'block'
                        }}
                    />
                </div>
            </div>

        </div>
    );
};

export default LoginPage;
